import { processTypes } from './processTypes'

const initialState = {
    orderProcess: {},
    loading: false,
    crudLoading: false,
}

const orderProcess = (state = initialState, action) => {
    switch (action.type) {
        // get a order process
        case processTypes.GET_A_ORDER_PROCESS_START:
            return {
                ...state,
                loading: true,
            }
        case processTypes.GET_A_ORDER_PROCESS_SUCCESS:
            return {
                ...state,
                orderProcess: action.payload,
            }
        case processTypes.GET_A_ORDER_PROCESS_FAILED:
            return {
                ...state,
                loading: false,
            }
        case processTypes.GET_A_ORDER_PROCESS_END:
            return {
                ...state,
                loading: false,
            }

        default:
            return state
    }
}

export default orderProcess
